import { Box } from '@ovComponents/1-primative/box/box';
import { Typography } from '@ovComponents/1-primative/typography/typography';
import type { OverviewRowProps } from './overviewRow.types';

export const OverviewRow = ({ sys, tokens, row }: OverviewRowProps) => (
  <Box sx={tokens.overviewRowGrid}>
    <Typography
      component='div'
      variant='labelSmall'
      sx={{ color: sys.color.onSurfaceVariant, alignSelf: 'start' }}
    >
      {row.label}
    </Typography>
    <Typography
      component='div'
      variant='bodySmall'
      sx={{ wordBreak: 'break-word' }}
    >
      {row.value}
    </Typography>
  </Box>
);
